// 403 surface (B5B §2.5: empty-state-with-rationale). PLAN-C1.9.
import { Link } from "@tanstack/react-router";
import { Lock } from "lucide-react";
import { Button } from "@/components/ui/button";

export function ForbiddenRoute() {
  return (
    <section className="flex flex-col items-center gap-3 px-5 py-16 text-center">
      <Lock className="size-8 text-muted-foreground" aria-hidden />
      <h1 className="text-2xl font-semibold tracking-tight">Not permitted</h1>
      <p className="text-muted-foreground">Your role doesn't grant access to this area.</p>
      <Button asChild variant="link">
        <Link to="/">← Back to dashboard</Link>
      </Button>
    </section>
  );
}
